module.exports = __webpack_public_path__ + "static/img/101390.4687c402.png";